export default __webpack_public_path__ + "static/wamo-text-mobile-8f0d859f0c3b2922be9e75950dd724eb.jpg";